// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-identity-picker-contact-icon {
  margin-right: 4px;
}

.bolt-identity-picker-unresolved-email,
.bolt-identity-picker-error {
  color: rgba(168, 0, 0, 1);
  color: var(--status-error-strong,rgba(168, 0, 0, 1));
}

/*# sourceMappingURL=IdentityPicker.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/IdentityPicker/IdentityPicker.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/IdentityPicker/IdentityPicker.css"],"names":[],"mappings":"AACA;EACI,iBCmTQ;ACnTZ;;AFGA;;EAEI,yBCoPgB;ECpPlB,oDAAoD;AACtD;;AAEA,6CAA6C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
